import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Metafield, Product } from 'src/app/shop';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';

@Component({
  selector: 'app-product-swatch-list',
  templateUrl: './product-swatch-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive, FromDictionaryPipe],
})
export class ProductSwatchListComponent {
  @Input() products!: Product[];
  @Input() activeProduct!: Product;

  hoverLabel?: string;

  getMetafield(product: Product, field: 'kleur_filter' | 'kleur_label' | 'kleurcode'): Metafield | undefined | null {
    return product.variants?.[0]?.metafields?.find(m => m?.key === field)
      || product.metafields?.find(m => m?.key === field);
  }

  getMetaImage(product: Product, field: string) {
    const image = product.variants?.[0]?.metafields?.find(m => m?.key === field)
      || product.metafields?.find(m => m?.key === field);
    return image?.reference?.image?.url ? `url('${image?.reference?.image?.url}')` : '';
  }

  getLabel(product: Product) {
    const fields = product.variants?.[0]?.metafields ?? product.metafields;
    const customLabel = fields?.find(m => m?.key === 'kleur_label');
    const filterLabel = fields?.find(m => m?.key === 'kleur_filter');
    return customLabel?.value || filterLabel?.value || '';
  }
}
